import React, { useState, useEffect } from "react"
import * as R from 'ramda'
import moment from 'moment'
import 'moment/locale/zh-tw'

import { connect } from 'react-redux'
import { getRecords, uploadRecord, getLeaderboard, getPartyRecord, syncProfile } from '../actions/party'

import PartyCompetition from '../components/PartyCompetition'

export function PartyUpload(props) {
    const recordType = "running"

    const [uploadData, setUplaodData] = useState({})
    const [pageCurrent, setPageCurrent] = useState(1)
    const [recordsToday, setRecordsToday] = useState({
        count: 0,
        list: [],
    })

    useEffect(() => {
        props.getRecords(recordType)
    }, [])

    useEffect(() => {
        if (!R.isEmpty(uploadData)) {
            props.uploadRecord(uploadData)
        }
    }, [uploadData])

    useEffect(() => {
        if (props.partyInfo.partyId) {
            props.getLeaderboard({
                partyId: props.partyInfo.partyId,
                page: pageCurrent - 1,
            })
            props.getPartyRecord(props.partyInfo.partyId)            
        }
    }, [props.partyInfo.partyId, props.hasUploaded, pageCurrent])

    useEffect(() => {
        let recordsTemp = []
        if (!R.isNil(props.records)) {
            if (props.records.count > 0) {
                for (let i in props.records.list) {
                    if (moment(props.records.list[i].recordTime * 1000).isSame(moment(), 'day')) {
                        recordsTemp.push(props.records.list[i])
                    }
                }
            }
        }

        setRecordsToday({
            count: recordsTemp.length,
            list: recordsTemp,
        })
    }, [props.records])

    useEffect(() => {
        if (props.partyInfo.partyId) {
            props.getLeaderboard({
                partyId: props.partyInfo.partyId,
                page: pageCurrent - 1,
            })
        }
    }, [props.userRecord])

    const handleSyncProfile = () => {
        props.syncProfile()
    }

    return (
        <div className="party-setting">
            <div className="party">
                <PartyCompetition
                    partyInfo={props.partyInfo}
                    records={recordsToday}
                    hasUploaded={props.hasUploaded}
                    leaderboard={props.leaderboard}
                    userRecord={props.userRecord}
                    setUplaodData={setUplaodData}
                    pageCurrent={pageCurrent}
                    setPageCurrent={setPageCurrent}
                    handleSyncProfile={handleSyncProfile}
                    synchronizing={props.synchronizing}
                />
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    partyInfo: state.party.partyInfo,
    records: state.party.records,
    hasUploaded: state.party.hasUploaded,
    leaderboard: state.party.leaderboard,
    userRecord: state.party.userRecord,
    synchronizing: state.party.synchronizing,
});

const mapDispatchToProps = {
    getRecords,
    uploadRecord,
    getLeaderboard,
    getPartyRecord,
    syncProfile,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PartyUpload)